import config from 'src/config';

fraudService.$inject = [
  'tl.keychain'
];

export default function fraudService(keychain) {
  class FraudService {
    constructor() {
      window._sift = [
        ['_setAccount', config.SIFT_KEY]
      ];
    }

    push(event, data) {
      if (!event) throw new Error('event is required');

      if (!this.loaded) {
        this.loadScript();
      }

      const track = [event];

      if (data) track.push(data);

      window._sift.push(track);
    }

    setUser(user) {
      this.push('_setUserId', user ? user.id : '');
      this.push('_setSessionId', keychain.prospectToken());
    }

    trackPageView() {
      this.push('_trackPageview');
    }

    loadScript() {
      this.loaded = true;
      const e = document.createElement('script');
      e.type = 'text/javascript';
      e.async = true;
      e.src = ('https:' === document.location.protocol ? 'https://' : 'http://') + 'cdn.siftscience.com/s.js'; //eslint-disable-line
      const s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(e, s);
    }
  }

  return new FraudService();
}



// WEBPACK FOOTER //
// ./src/services/fraudService.js